module.exports = __webpack_public_path__ + "static/media/logos_desktop.16edf0c4.png";